import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-shots',
  templateUrl: './shots.component.html',
  styleUrls: ['./shots.component.scss'],
})
export class ShotsComponent {

  constructor() { }

}
